/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Theme props for Account Select component
 *
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.2.0
 */

export const displayItemBalanceWidth = 152;
export const displayItemNumberWidth = 140;

export const listItemBalanceWidth = 172;
export const listItemNumberWidth = 180;
